import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, IBase } from "mobx-stores/_models/base";
import { Product } from "mobx-stores/_models/products/product";

export const ProductGoodsIssueItem = types
  .compose(
    Base,
    types.model({
      productId: types.maybeNull(types.string),
      product: types.maybeNull(Product),
      quantity: types.maybeNull(types.number),
      note: types.maybeNull(types.string),
    })
  )
  .actions(withSetPropAction);
export interface IProductGoodsIssueItem
  extends Instance<typeof ProductGoodsIssueItem> {}
export interface IProductGoodsIssueItemProperties
  extends SnapshotIn<typeof ProductGoodsIssueItem> {}

export interface IAddProductGoodsIssueItem
  extends Omit<IProductGoodsIssueItemProperties, "product" | keyof IBase> {}

export interface IUpdateProductGoodsIssueItem
  extends Omit<IProductGoodsIssueItemProperties, "product"> {}
